import { GlobalSettingsConfig, ShopConfig } from '@rc-d2c/context-manager';
import { useStore } from 'zustand';

export const useFormattedPrice = () => {
  const { currency } = useStore(ShopConfig.ShopStore, (state) => state);
  const { language } = useStore(GlobalSettingsConfig.GlobalSettingsStore, (state) => state);

  function formatPrice(price?: null): null;
  function formatPrice(price: number): string;
  function formatPrice(price?: number | null): string | null;
  function formatPrice(price: number | null = null) {
    return price !== null ? new Intl.NumberFormat(language, { style: 'currency', currency }).format(price) : null;
  }

  return { formatPrice };
};

export default useFormattedPrice;
